/* tslint:disable:file-name-casing */
/**
 * Main file
 */
import "@babel/polyfill";
import { Provider as RollbarProvider } from "@rollbar/react";
import "classlist.js";
import { ErrorReducer } from "components/Error/store/Reducer";
import { OverlayReducer } from "components/OverLay/store/Reducer";
import { CajitaLayout } from "containers/CajitaLayout/CajitaLayoutComponent";
import { CardReducer } from "containers/Card/store/Reducer";
import { CardAsyncReducer } from "containers/CardAsync/store/Reducer";
import { CardSubscriptionAsyncReducer } from "containers/CardSubscriptionAsync/store/Reducer";
import { CashReducer } from "containers/Cash/store/Reducer";
import { PayoutsCashReducer } from "containers/PayoutsCash/store/Reducer";
import { TransferReducer } from "containers/Transfer/store/Reducer";
import { TransferSubscriptionAccendoReducer } from "containers/TransferSubscriptionAccendo/store/Reducer";
import { TransferSubscriptionReducer } from "containers/TransferSubscriptions/store/Reducer";
import "core-js/client/shim";
import "core-js/es6/array";
import "core-js/es6/date";
import "core-js/es6/function";
import "core-js/es6/map";
import "core-js/es6/math";
import "core-js/es6/number";
import "core-js/es6/object";
import "core-js/es6/parse-float";
import "core-js/es6/parse-int";
import "core-js/es6/reflect";
import "core-js/es6/regexp";
import "core-js/es6/set";
import "core-js/es6/string";
import "core-js/es6/symbol";
import "core-js/es6/weak-map";
import "core-js/es7/reflect";
import "core-js/fn/symbol/iterator";
import "es6-symbol";
import "raf/polyfill";
import * as React from "react";
import * as ReactDOM from "react-dom";
import { hot } from "react-hot-loader";
import { LocalizeProvider } from "react-localize-redux";
import { Provider } from "react-redux";
import { BrowserRouter, Route } from "react-router-dom";
import { applyMiddleware, combineReducers, createStore, Store } from "redux";
import { composeWithDevTools } from "redux-devtools-extension";
import reduxThunk from "redux-thunk";
import rollbar from "rollbar";
import { environment } from "root/environments/environment";
import { HelpersReducer } from "root/store/helpers/Reducer";
import { ConfigReducer } from "root/store/Reducer";
import "url-polyfill";
import "web-animations-js";
import "./index.css";

const { dependencies } = require("../package.json");
// tslint:disable-next-line:no-any
declare const module: any;

const store: Store = createStore(
  combineReducers({
    config: ConfigReducer,
    card: CardReducer,
    transfer: TransferReducer,
    transferSubscriptions: TransferSubscriptionReducer,
    transferSubscriptionAccendo: TransferSubscriptionAccendoReducer,
    cash: CashReducer,
    payouts_cash: PayoutsCashReducer,
    card_async: CardAsyncReducer,
    card_subscription_async: CardSubscriptionAsyncReducer,
    error: ErrorReducer,
    showOverlay: OverlayReducer,
    helpers: HelpersReducer,
  }),
  composeWithDevTools(applyMiddleware(reduxThunk))
);

const rollbarConfig: rollbar.Configuration = {
  accessToken: environment.rollbarId,
  addErrorContext: true,
  autoInstrument: true,
  captureUncaught: true,
  captureUnhandledRejections: true,
  environment: environment.envName,
  payload: {
    client: {
      javascript: {
        code_version: dependencies["@kushki/js"],
        source_map_enabled: true,
      },
    },
    environment: environment.envName,
  },
};

hot(module)(
  ReactDOM.render(
    <LocalizeProvider>
      <RollbarProvider config={rollbarConfig}>
        <Provider store={store}>
          <BrowserRouter>
            <Route path="/" component={CajitaLayout} />
          </BrowserRouter>
        </Provider>
      </RollbarProvider>
    </LocalizeProvider>,
    document.getElementById("root") as HTMLElement
  )
);



// WEBPACK FOOTER //
// ./src/index.tsx